<template>
    <div class="absolute inset-0 bg-white bg-opacity-75 flex flex-col items-center justify-center z-50 rounded-xl">
        <lottie :options="lottieOptions" :height="250" :width="250" />
        <p class="text-lg text-gray-800 -mt-4 font-semibold">
            Sedang mengambil data, mohon tunggu...
        </p>
    </div>
</template>

<script>
import Lottie from 'vue-lottie';
import * as animationData from '@/assets/animations/monkey-running.json';

export default {
    name: 'MonkeyLoader',
    components: {
        'lottie': Lottie
    },
    data() {
        return {
            lottieOptions: {
                animationData: animationData.default,
                loop: true
            }
        };
    }
};
</script>